import React from 'react';

import Company from './Company';

async function getCompanyInfo(nid) {
  const response = await fetch(
    `/${drupalSettings.current_language}/api/opening_hours/${nid}`
  );

  if (response.ok) {
    const data = await response.json();
    return {
      data,
      status: 'OK',
    };
  } else {
    return { status: 'request failed' };
  }
}

export async function getCompanyList(companies) {
  const fetchOpeningHours = companies.map((company) =>
    getCompanyInfo(company.nid)
  );
  const companyInfo = await Promise.all(fetchOpeningHours);

  const companyElements = companies.map((company, i) => {
    if (companyInfo[i].status === 'OK' && companyInfo[i].data.opening_hours) {
      const openingHours = JSON.parse(companyInfo[i].data.opening_hours);

      return (
        <Company
          key={i}
          title={company.title}
          website={companyInfo[i].data.website ?? null}
          map={companyInfo[i].data.map ?? null}
          openingHours={openingHours}
        />
      );
    } else {
      return null;
    }
  });

  return companyElements;
}
